(ns core.front.portal
  (:require [react-dom]
            [reagent.core :as r]))

(defn render-in-portal
  "Render el in react portal, optional container element for the portal (ID string or DOM node)"
  ([el]
   (render-in-portal el nil))
  ([el container]
   (let [container (cond->> container
                     (string? container) (.getElementById js/document))]
     (react-dom/createPortal
       (r/as-element el)
       (or container (-> js/document .-body))))))
